import React from 'react';

import SummaryBlock from '../SummaryBlock';

const RenderComponentBasedOnBlock = (props) => {
    const { block, blockState } = props

    return (
        <React.Fragment>
            {
                (function () {
                    switch (block.type) {
                        case "summaryItems":
                            return <SummaryBlock key={block.name} block={block} blockState={blockState} {...props} />
                            break;
                        default:
                            return null;
                    }
                })()
            }
        </React.Fragment>
    )
}

export default RenderComponentBasedOnBlock